// extracted by mini-css-extract-plugin
module.exports = {"Header":"header_Header__XFi2q","Logo":"header_Logo__1GfaA","Controls":"header_Controls__10zN8"};